import { styled, Tab } from "@mui/material";
import * as React from "react";

const Component = styled(Tab)(_ => ({
    fontSize: "14px",
    textTransform: "initial",
}));

export default Component;
